import { IClinic } from './clinic.model';
import { IPatient } from './patient.model';
import { IUser } from './user.model';

export enum EInventoryItemStandardPackagingUnitEnum {
  ampouled = 'ampouled',
  bag = 'bag',
  bottle = 'bottle',
  box = 'box',
  bundle = 'bundle',
  capsule = 'capsule',
  case = 'case',
  container = 'container',
  cream = 'cream',
  each = 'each',
  gel = 'gel',
  nebule = 'nebule',
  ointment = 'ointment',
  pack = 'pack',
  pair = 'pair',
  pallet = 'pallet',
  patch = 'patch',
  pcs = 'pcs',
  pill = 'pill',
  plastic = 'plastic',
  polyamp = 'polyamp',
  roll = 'roll',
  set = 'set',
  spray = 'spray',
  suppository = 'suppository',
  suspension = 'suspension',
  syrup = 'syrup',
  tablet = 'tablet',
  tray = 'tray',
  tube = 'tube',
  vial = 'vial'
}

export enum EInventoryItemType {
  MEDICATION = 'MEDICATION',
  EQUIPMENT = 'EQUIPMENT',
  CLOTHES = 'CLOTHES'
}

export enum EInventoryItemBaseUnitOfMeasure {
  GRAM = 'g',
  MILLIGRAM = 'mg',
  MILLILITER = 'ml',
  LITERS = 'l',
  IU = 'IU'
}

export enum EInventoryItemQuantityChangeType {
  DISBURSEMENT = 'DISBURSEMENT',
  PURCHASE = 'PURCHASE',
  DONOR = 'DONOR',
  TRANSFER = 'TRANSFER',
  REBASE = 'REBASE'
}

export enum EPatientDisbursementFrequency {
  ONCEDAILY = 'ONCEDAILY',
  TWICEDAILY = 'TWICEDAILY',
  EVERY6HOURS = 'EVERY6HOURS',
  EVERY8HOURS = 'EVERY8HOURS'
}

export enum EInventoryItemQuantityChangeTypeREBASE {
  LOST = 'LOST',
  EXPIRED = 'EXPIRED',
  RETURNED = 'RETURNED',
  ADJUSTEDNUMBER = 'ADJUSTEDNUMBER',
}

export enum EInventoryItemsListTableFieldsDisplay {
  ALL = 'ALL',
  INVENTORYDETAILS = 'INVENTORYDETAILS',
  EXPIRYDATE = 'EXPIRYDATE'
}

export enum EDrugAdministrationMode {
  ORAL = 'ORAL',
  SUBLINGUAL = 'SUBLINGUAL',
  RECTAL = 'RECTAL',
  INTRAVENOUS = 'INTRAVENOUS',
  INTRAMUSCULAR = 'INTRAMUSCULAR',
  SUBCUTANEOUS = 'SUBCUTANEOUS',
  INTRANASAL = 'INTRANASAL',
  INHALED = 'INHALED',
  VAGINAL = 'VAGINAL'
}
export enum EInventoryExpiryStatus {
  MORETHAN3MONTHS = 'MORETHAN3MONTHS',
  WITHIN3MONTHS = 'WITHIN3MONTHS',
  EXPIRED = 'EXPIRED'
};
export interface IInventoryCategory {
  _id?: string;
  name: string; // e.g. part of body
  options: string[]; // e.g. [head, stomach, full body]
}
export interface IInventoryItem {
  _id?: string;
  name: string;
  sku: number;
  quantity: number;
  description?: string;
  modeOfAdministration: string; // e.g. oral, IV
  type: EInventoryItemType;
  standardPackagingUnit: EInventoryItemStandardPackagingUnitEnum;
  baseUnitOfMeasure: EInventoryItemBaseUnitOfMeasure;
  standardQuantityForBaseUnitOfMeasure: number;
  reorderLevel: number; // i.e. at what quantity should we send a notification to reorder the item
}
export interface IInventoryItemCategory {
  _id?: string;
  item: IInventoryItem;
  category: IInventoryCategory;
  value: string; // e.g. head
}
export interface IPrescription {
  _id?: string;

}
export interface IInventoryItemQuantity {
  _id?: string;
  item: IInventoryItem;
  facility: IClinic;
  quantity: number;
  quantityChangeType: EInventoryItemQuantityChangeType;
  createdBy: IUser;
  lastModifiedBy: IUser;
  lotSerialNumber?: string;
  expiryDate?: string; // this is a date
  patient?: IPatient;
  purchasePrice?: string;
  donorName?: string;
  facilityFrom?: IClinic;
  facilityTo?: IClinic;
  patientDisbursementFrequency?: EPatientDisbursementFrequency;
  prescriptionId?: IPrescription;
  packageUnit?: EInventoryItemStandardPackagingUnitEnum;
  packagingUnitQuantity?: number;
  packagingUnitConversion?: number; // i.e. how many items does a {packageUnit} have. Use this value to multiple {packagingUnitQuantity * packagingUnitConversion} and get total items added
  visitId?: string;
}

/*
  REBASE - give reason
*/


